module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2i"
  }, [_c('a', {
    attrs: {
      "id": "ch03"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER")]), _vm._v(" 3")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "imagela"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/line.jpg",
      "width": "150px"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "h2title"
  }, [_vm._v("India")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("C")]), _vm._v("aptain Thomas Bogardus recalled that as the "), _c('em', [_vm._v("Lurline")]), _vm._v(" sailed west across the Pacific, “some troop training of sorts” was carried out on deck. ")]), _c('a', {
    attrs: {
      "id": "prolog37"
    }
  }, [_vm._v("“The main swimming pool was drained and turned into a training area, as were several different corners of the ship and state rooms,” said Bogardus. “We did some training in first aid, map reading, and the like… . One of the unique training sessions consisted of learning how to give blood transfusions.”")])]), _c('a', {
    attrs: {
      "id": "prolog37"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog37"
    }
  }, [_vm._v("The transfusions were demonstrated by the detachment’s 104-strong medical personnel, one of whom was Technician 4th Grade Richard Murch, a twenty-two-year-old who before the war had worked for the Continental Bank and Trust in New York City. Murch had initially been rejected by the Army on the grounds of poor physique, a rebuff that caused him to wander the streets of Manhattan in “shame.” Six months later, the Army relaxed the recruitment criteria and Murch was in, assigned to Fort Dix in New Jersey and then to Billings General Hospital, where he qualified as a medical surgical assistant and anesthetist in early 1943. Murch remembered that on board the "), _c('em', [_vm._v("Lurline")]), _vm._v(", the medical personnel ")]), _c('a', {
    attrs: {
      "id": "prolog38"
    }
  }, [_vm._v("“would meet every morning for three or four hours, trying to find the strengths and weaknesses of each person, assigning duties to fit each person’s capabilities.”")])]), _c('a', {
    attrs: {
      "id": "prolog38"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog38"
    }
  }, [_vm._v("As the voyage wore on, the initial excitement dissipated and the 1,800 soldiers began chafing at their humdrum existence. At night, all portholes and doors had to be closed for security purposes. The heat inside the ship was unbearable, remembered Bogardus, ")]), _c('a', {
    attrs: {
      "id": "prolog39"
    }
  }, [_vm._v("“and we were soaking wet with perspiration a good part of the time.”")])]), _c('a', {
    attrs: {
      "id": "prolog39"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog39"
    }
  }, [_vm._v("To break the monotony, a boxing ring was installed on one of the decks and men fought each other over two rounds. Richard Murch was beaten by a fellow ")]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("medic, Thomas Finnegan, but in the poker school that he ran from a cabin, he met with greater success. When the green hills of New Caledonia were spotted after twelve days at sea, Murch was $600 richer than he’d been in San Francisco.")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Within a few hours of arriving in the broad harbor of Noumea, capital of New Caledonia, the men were pressed against the deck railings watching 670 combat veterans of the South Pacific climb up ladders from the iron barges below. Their uniforms were dirty, their boots scuffed, and their unshaven faces a strange shade of yellow from their anti-malaria pills. To Lt. Phil Weld, a Harvard graduate and former journalist with the "), _c('em', [_vm._v("Chicago Daily News")]), _vm._v(", the men coming aboard appeared to be ascending “from another world.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("The veterans were similarly intrigued by what they discovered once on board the "), _c('em', [_vm._v("Lurline")]), _vm._v(". Edward C. Kohler, a twenty-two-year-old sergeant who had spent weeks fighting the Japanese in the jungle of Guadalcanal and then in the swamps of New Georgia, expected more. ")]), _c('a', {
    attrs: {
      "id": "prolog40"
    }
  }, [_vm._v("“The ship could stand a good cleaning and the food needed a lot of improvement,” he remembered.")])]), _c('a', {
    attrs: {
      "id": "prolog40"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Like their spick-and-span comrades who had sailed from San Francisco, the South Pacific veterans reflected their country’s rich diversity. Kohler was from St Mary’s, Ohio, a National Guardsman mobilized into the 148th Infantry, 37th Division and shipped to the Pacific in 1942.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog40"
    }
  }, [_vm._v("Werner Katz was a twenty-one-year-old German Jew who had fled his homeland in the late 1930s and arrived in New York.")]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03fn01",
      "id": "ch03fn01a"
    }
  }, [_vm._v("*")]), _vm._v(" Katz had enlisted in the U.S. Army in early 1941 while he was still waiting to receive his citizen papers, and in January 1942 he volunteered to go with the 182nd Infantry Regiment to Australia. From Melbourne, the 182nd shipped out to Guadalcanal in November, and Katz distinguished himself during the fighting on the Pacific island.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bernard Martin also landed on Guadalcanal, but during his stint on the island with the 43rd Signal Company, he had seen little in the way of action. The twenty-one-year-old from Rhode Island was one of the best radio operators in his unit, capable of sending twenty words a minute when the average was half that figure. "), _c('a', {
    attrs: {
      "id": "prolog41"
    }
  }, [_vm._v("“I spent about two weeks on Guadalcanal before being transferred to another island,” recalled Martin, a man who lived on the sunny side of life. “I was furnishing messages to base when all of a sudden a message came in stating ‘looking for volunteers for a dangerous mission.’ I thought it over for two days and volunteered. I was bored with what I was doing. I wanted to be involved; I wanted to fight.”")])]), _c('a', {
    attrs: {
      "id": "prolog41"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog41"
    }
  }, [_vm._v("Two officers newly arrived on the "), _c('em', [_vm._v("Lurline")]), _vm._v(" had both volunteered despite weeks of heavy fighting in the South Pacific. First Lieutenant Ted McLogan, twenty-three, was reading political science at the University of Michigan on ")]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("December 7, 1941, when the news broke in his fraternity house of the attack on Pearl Harbor. McLogan recalled that he and his friends ")]), _c('a', {
    attrs: {
      "id": "prolog42"
    }
  }, [_vm._v("“picked up a long-handled broom and we marched around the room, almost as if it were a big joke, not realizing the seriousness of it at that moment.”")])]), _c('a', {
    attrs: {
      "id": "prolog42"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog42"
    }
  }, [_vm._v("Having served in the ROTC at Michigan, McLogan was commissioned into the 35th Infantry Regiment, 25th Division, and then shipped to the South Pacific, where he was blooded in combat on the island of Vella Lavella. Not long after the island had been secured, McLogan received an order to assemble his men for an important announcement. ")]), _c('a', {
    attrs: {
      "id": "prolog43"
    }
  }, [_vm._v("“So I got my guys out of their foxholes and this major came along,” remembered McLogan. “He opened up a file and said: ‘The War Department is looking for volunteers for a dangerous and hazardous mission in another theater of operations. You may have one minute to think about it, and if you’re going to volunteer take one step forward. We need you here; there’s no pressure for you to volunteer. It’s entirely voluntary and the option is yours.’”")])]), _c('a', {
    attrs: {
      "id": "prolog43"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("For a few moments, no one moved. McLogan then heard a stage whisper from behind. “Here’s your chance, Mac.” It was McLogan’s sergeant, a laconic West Virginian by the name of Paul Michael. “So I said, ‘I will, if you will,’” remembered McLogan. “I knew he wasn’t going to [volunteer] because he was one of these regular Army guys. He had challenged me, and I had to respond in front of the men.” But McLogan had underestimated his sergeant. Michael volunteered, and so did he.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog43"
    }
  }, [_vm._v("The pair was among the thirty-two men from the five hundred-strong 35th Infantry Regiment who volunteered for the unknown assignment. Included in that sparse number was Pvt. Gabriel Kinney, a twenty-two-year-old from Cullman County, Alabama. On the day of Pearl Harbor, Kinney was working the day shift in the iron ore mines of Birmingham. The death of his father the following month delayed Kinney’s enlistment into the Army, but by the end of 1942 he was a member of Company F of the 35th Infantry Regiment, McLogan’s company. Kinney recalled being enticed into volunteering with the promise that ")]), _c('a', {
    attrs: {
      "id": "prolog44"
    }
  }, [_vm._v("“when the mission was complete we would be returned to the States … that sounded good to me.”")])]), _c('a', {
    attrs: {
      "id": "prolog44"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog44"
    }
  }, [_vm._v("Another officer who joined the "), _c('em', [_vm._v("Lurline")]), _vm._v(" in New Caledonia was Lt. Logan Weston, a twenty-nine-year-old Pennsylvanian drafted into the heavy weapons unit of the 145th Regiment of the 37th Infantry Division in early 1941, while studying to become a preacher at the Transylvania Bible School. Two years later Weston, now an officer, took his first life fighting on Guadalcanal. “My self-condemnation weighed heavily on my mind,” he wrote later. “But then I began to understand. The way I saw it, I was not only preserving my own life but doing what was necessary to see that our democratic freedoms remained intact.” Weston turned to God for guidance and ")]), _c('a', {
    attrs: {
      "id": "prolog45"
    }
  }, [_vm._v("“felt peace in my heart that I was doing the right thing.”")])]), _c('a', {
    attrs: {
      "id": "prolog45"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog45"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("On board the "), _c('em', [_vm._v("Lurline")]), _vm._v(", Weston lectured those of his fellow officers untested in combat on what to expect when the day arrived. Some of what he imparted was practical information: that grenades were the most effective weapon in thick jungle, and moving through the dense undergrowth was similar to feeling your way across a dark room.")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("But Weston was also at pains to dispel the popular image back home, spread in the newspapers and on the newsreels, that the Japanese soldier was weak and cowardly. Not at all; he was tenacious, cunning, and bewilderingly brave.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("There were other lectures, too, from the newly arrived combat veterans, including talks from medical officers on the importance of halazone tablets to sterilize water")]), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03fn02",
      "id": "ch03fn02a"
    }
  }, [_vm._v("*")]), _vm._v(" and of taking atabrine to combat malaria, regardless of the fact that it turned the skin yellow.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The "), _c('em', [_vm._v("Lurline")]), _vm._v(" stopped briefly at Brisbane on the east coast of Australia to collect the final detachment of volunteers—270 officers and men from the Southwest Pacific Command, of whom the majority had no combat experience. The ship, accompanied by a Dutch destroyer, then continued around the southern tip of Australia, sailing up a channel into the port of Fremantle on the west coast of the country. "), _c('a', {
    attrs: {
      "id": "prolog46"
    }
  }, [_vm._v("“The houses as you enter this channel are on the right side on steep cliffs,” remembered Capt. Thomas Bogardus. “As we came in through this channel, the people of almost every house came out with bed sheets, pillow cases, and towels and waved them in the air. This was probably the first troop ship that they had ever seen, and they were welcoming the Americans.”")])]), _c('a', {
    attrs: {
      "id": "prolog46"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Once the "), _c('em', [_vm._v("Lurline")]), _vm._v(" was at anchor, the men of the 1688th Casual Detachment were allowed ashore for the first time in six weeks. The 1st Battalion disembarked first, followed by the 2nd, and then the 3rd. They marched through the streets of the quaint town, whose design owed much to the English emigrants who had first settled Fremantle, and were cheered all the way by the Australians. “Barmaids from the local pubs came out with their hands filled with mugs of beer, passing them to the troops,” said Bogardus.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog46"
    }
  }, [_vm._v("The "), _c('em', [_vm._v("Lurline")]), _vm._v(" took on supplies in Fremantle and then headed northwest into the Indian Ocean. But to where exactly? ")]), _c('a', {
    attrs: {
      "id": "prolog47"
    }
  }, [_vm._v("“To our knowledge there weren’t any American troops in combat in this area of the world,” recalled Bogardus. “It left us up in the air as to where we might be going, although India seemed our next area where we might stop.”")])]), _c('a', {
    attrs: {
      "id": "prolog47"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog47"
    }
  }, [_vm._v("Not long out of Fremantle, Colonel Hunter opened ")]), _c('a', {
    attrs: {
      "id": "prolog48"
    }
  }, [_vm._v("“the ship’s safe, and sealed material from Washington was delivered to the various battalions indicating what kind of equipment we were to have and what kind of ")]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("organization we would finally become.” The orders also revealed their destination—India.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("The "), _c('em', [_vm._v("Lurline")]), _vm._v(" docked in Bombay, halfway up the west coast of India, on October 29. The 1st Battalion was first off the ship, followed a day later by the 2nd Battalion. Captain Thomas Bogardus was appalled by what he saw of Bombay as they marched through the city to the railway station. ")]), _c('a', {
    attrs: {
      "id": "prolog49"
    }
  }, [_vm._v("“The native Indians were living in cardboard boxes for shelter,” he recalled. “You could see people on the verge of dying right along the railroad tracks. I shall never forget the soulful look of these starving masses of humanity as we passed.”")])]), _c('a', {
    attrs: {
      "id": "prolog49"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The 3rd Battalion remained on board the "), _c('em', [_vm._v("Lurline")]), _vm._v(" for a further twenty-four hours, much to the annoyance of one of its medical officers, Capt. James Hopkins. “The only entertainment was provided by watching the Indian dockworkers [and], the attitude of the men was further disturbed by the heat, not only on the outside but also on the inside of the poorly ventilated ship,” he recalled. Hopkins’s great-great uncle was Johns Hopkins, founder of the famous hospital, university, and medical school in Baltimore, from where he himself had graduated in 1941. Pearl Harbor compelled Hopkins to interrupt his first year of surgical training to enlist, and he was soon serving as a surgeon with the 18th General Hospital in Fiji before volunteering to join the 148th Infantry Regiment on Guadalcanal as their assistant surgeon.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog49"
    }
  }, [_vm._v("Imprisoned on board the "), _c('em', [_vm._v("Lurline")]), _vm._v(" in Bombay, Bernard Martin struck up a friendship with a fellow member of the 3rd Battalion. Wilbur Smawley—he preferred “Bill”—came from Pullman, Washington, and was the same age as Martin. ")]), _c('a', {
    attrs: {
      "id": "prolog50"
    }
  }, [_vm._v("“Bill and I became instant friends,” recalled Martin, who was delighted to find someone who shared his interest in radios. “He was bashful and shy, a really nice kid.”")])]), _c('a', {
    attrs: {
      "id": "prolog50"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The 3rd Battalion eventually disembarked on October 31 and marched through the city to the station, where they boarded a train. It took several hours for the antiquated train to cover the 125 miles to a village called Nasik. The men sat on wooden benches facing inwards, and trips to the bathroom were fraught with danger as the train jolted northeast. There was nothing but a hole in the floor that opened to the tracks below, and a good sense of balance was required if a soldier wished to return to his bench with his boots still respectable.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the Americans arrived in Nasik, they encountered a town that conformed to the western stereotype of India. The bazaar sold exotic spices, sparkling jewels, and ornamental rugs. Natives organized cobra and mongoose fights in the alleyways, and British officers strode down the street trailed by their Indian servants.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog50"
    }
  }, [_vm._v("Not that men of the 1688th Detachment were given much time to take it all in. They marched through Nasik and onward two miles to a transient camp at Deolali, where the men were billeted in tents. The officers, recounted ")]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Capt. Thomas Bogardus, were quartered in “row after row of small cubicles about twelve feet square, with two bunks in each cubicle and a door to an outhouse that was perhaps three or four feet square.” To each cubicle was assigned a local boy whose job it was to ")]), _c('a', {
    attrs: {
      "id": "prolog51"
    }
  }, [_vm._v("“bring us hot tea and shake us, which in essence was our alarm clock,” Bogardus said. In return, the boy received thirty-three cents a week, with a shave costing an additional three cents for officers and men alike.")])]), _c('a', {
    attrs: {
      "id": "prolog51"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "prolog51"
    }
  }, [_vm._v("Captain James Hopkins wasn’t alone in finding the food at their camp substandard. “The quality and quantity were poor,” he recalled, and meals were eaten in “disappointment and revulsion.” On one occasion, a soldier bit into his bread and into a mouse. ")]), _c('a', {
    attrs: {
      "id": "prolog52"
    }
  }, [_vm._v("“The mouse must have fallen into the dough and then been baked with the bread,” said Richard Murch, who witnessed the incident. Already, the relative luxury of the "), _c('em', [_vm._v("Lurline")]), _vm._v(" was a distant memory.")])]), _c('a', {
    attrs: {
      "id": "prolog52"
    }
  }), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "id": "prolog52"
    }
  }), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03fn01a",
      "id": "ch03fn01"
    }
  }, [_vm._v("*")]), _vm._v("Later Katz Anglicized his name to Warner, but for the purpose of clarity, he shall be referred to as Werner throughout.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03fn02a",
      "id": "ch03fn02"
    }
  }, [_vm._v("*")]), _vm._v("It was subsequently discovered by the unit’s medical officers that halazone did not kill the amoebic ova responsible for intestinal infections.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7249d7aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch03.vue
// module id = 81
// module chunks = 0